import gql from 'graphql-tag'

export default gql`
query getFAPriceLevels {
	cashAssist {
		getAppConfig {
			priceLevelsLinkFA
			priceLevelsCafeLinkFA
		}
	}
}
`
